var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#DCDCDC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.9583 22.2915H40V57.7082H63.9583V22.2915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9585 58.75H43.1252C42.5494 58.75 42.0835 58.2841 42.0835 57.7083C42.0835 57.1326 42.5494 56.6667 43.1252 56.6667H62.9168V23.3333H43.1252C42.5494 23.3333 42.0835 22.8674 42.0835 22.2917C42.0835 21.7159 42.5494 21.25 43.1252 21.25H63.9585C64.5343 21.25 65.0002 21.7159 65.0002 22.2917V57.7083C65.0002 58.2841 64.5343 58.75 63.9585 58.75Z",
    fill: "#177848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1667 15L15 20.4348V59.5652L44.1667 65V15Z",
    fill: "#177848"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15 20.4348V20.9556L44.1667 15.5208V15L15 20.4348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4168 25.4165H42.0835V29.5832H50.4168V25.4165Z",
    fill: "#177848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8333 25.4165H52.5V29.5832H60.8333V25.4165Z",
    fill: "#177848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4168 31.6665H42.0835V35.8332H50.4168V31.6665Z",
    fill: "#177848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8333 31.6665H52.5V35.8332H60.8333V31.6665Z",
    fill: "#177848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4168 37.9165H42.0835V42.0832H50.4168V37.9165Z",
    fill: "#177848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8333 37.9165H52.5V42.0832H60.8333V37.9165Z",
    fill: "#177848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4168 44.1665H42.0835V48.3332H50.4168V44.1665Z",
    fill: "#177848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8333 44.1665H52.5V48.3332H60.8333V44.1665Z",
    fill: "#177848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4168 50.4165H42.0835V54.5832H50.4168V50.4165Z",
    fill: "#177848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8333 50.4165H52.5V54.5832H60.8333V50.4165Z",
    fill: "#177848"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M15 59.5653L44.1667 65.0001V64.4792L15 59.0444V59.5653Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9582 58.75C64.5339 58.75 64.9998 58.2841 64.9998 57.7083V42.0833L44.1665 21.25V58.75H63.9582Z",
    fill: "url(#paint0_linear_57_412)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3285 41.0418L35.1151 32.4257L35.0547 32.3921L31.4159 32.652L28.5417 37.8256L25.8867 33.0469L22.4497 33.2924L26.7548 41.0418L22.4497 48.7912L25.8867 49.0366L28.5417 44.258L31.4159 49.4316L35.0547 49.6915L35.1151 49.6579L30.3285 41.0418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M44.1667 15L15 20.4348V59.5652L44.1667 65V15Z",
    fill: "url(#paint1_linear_57_412)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9583 21.25H44.1667V15L15 20.4348V59.5652L44.1667 65V58.75H63.9583C64.5341 58.75 65 58.2841 65 57.7083V22.2917C65 21.7159 64.5341 21.25 63.9583 21.25Z",
    fill: "url(#paint2_linear_57_412)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_57_412",
    x1: 34.7915,
    y1: 30.625,
    x2: 63.6532,
    y2: 59.4867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_57_412",
    x1: 14.9983,
    y1: 39.9989,
    x2: 44.1668,
    y2: 39.9989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_57_412",
    x1: 11.7428,
    y1: 27.4199,
    x2: 67.1779,
    y2: 53.2697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excel-icon.f3cc96a10d0c5b3c7a90157b95b0b3b1.svg";
export { ForwardRef as ReactComponent };